import { Models } from "@hex-insights/app-modules";
import { ContractInstallment } from "../../../Utilities";
import * as ModelFormat from "../_General";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the dueDate field of the ContractInstallment model.
 */
export function dueDate(value: ContractInstallment["dueDate"] | null, options?: Intl.DateTimeFormatOptions): string {
	return ModelFormat.date(value, options);
}

/**
 * Formats the portion field of the ContractInstallment model.
 */
export function portion(value: ContractInstallment["portion"] | null): string {
	return Models.toString(value);
}
